import { render, staticRenderFns } from "./row-value.vue?vue&type=template&id=1f21fff1"
import script from "./row-value.vue?vue&type=script&lang=js"
export * from "./row-value.vue?vue&type=script&lang=js"
import style0 from "./row-value.vue?vue&type=style&index=0&id=1f21fff1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports